import { __decorate, __metadata } from "tslib";
import { TypedStorage } from "./TypedStorage";
import { injectable } from "inversify";
let TypedLocalStorage = class TypedLocalStorage extends TypedStorage {
    constructor(key, defaultValue) {
        super(localStorage, key, defaultValue);
    }
};
TypedLocalStorage = __decorate([
    injectable(),
    __metadata("design:paramtypes", [String, Object])
], TypedLocalStorage);
export { TypedLocalStorage };
//# sourceMappingURL=TypedLocalStorage.js.map